import AsyncSelect from 'react-select/async';
import { getRandomUid } from 'utilities/uuid.service';
import { useEffect, useState } from 'react';
import usePlans from 'hooks/API/GET/usePlans';

function MultiplePlanSelector({
  enableAPI,
  isMulti,
  values,
  handleChange,
  options = [],
  dependencies = {},
}) {
  const { query = {} } = dependencies;
  const [plans, setPlans] = useState([]);
  const [defaultPlans, setDefaultPlans] = useState([]);

  // Only call API if enableAPI is true
  const { data, isLoading } = usePlans({
    enabled: enableAPI && (!options || options.length === 0), // Only fetch if no static options
    configs: { params: { mode: 'dropdown', ...query } },
  });

  const _id = getRandomUid();

  useEffect(() => {
    // If options are provided (static), use them; otherwise fetch from API
    if (options && Array.isArray(options) && options.length > 0) {
      setPlans(options);
    } else if (data?.data && Array.isArray(data.data) && data.data.length > 0) {
      setPlans(data.data.map((item) => ({ label: item.name, value: item._id })));
    } else {
      setPlans([]);
    }
  }, [data?.data, options]);

  useEffect(() => {
    setDefaultPlans(values ?? []);
  }, [values]);

  return (
    <>
      <label htmlFor={_id}>Plans</label>
      <AsyncSelect
        styles={{
          control: (baseStyles, state) => ({
            ...baseStyles,
            borderColor: '#e9baf0',
            'box-shadow': '0 0.8rem 1.2rem rgba(20, 102, 204, 0.14)',
          }),
          multiValue: (styles) => {
            return {
              ...styles,
              backgroundColor: '#fadbff',
            };
          },
        }}
        inputId={_id}
        isMulti={isMulti}
        cacheOptions
        isLoading={isLoading || (enableAPI && plans.length === 0 && !options?.length)}
        onChange={handleChange}
        defaultOptions={plans}
        options={plans}
        value={defaultPlans}
        isDisabled={plans.length === 0}
      />
    </>
  );
}

MultiplePlanSelector.defaultProps = {
  values: [],
  isMulti: true,
  options: [],
  handleChange: () => {},
};

export default MultiplePlanSelector;
